import { EmailIcon, TextIcon, AirDropIcon, SurveyIcon, QRIcon, PrintIcon } from '../Icons';

const ShareDemo = ({ email, text, airDrop, survey, qr, print }) => {
  const groups = [
    email ? { name: 'Email', Icon: EmailIcon } : null,
    text ? { name: 'Text', Icon: TextIcon } : null,
    airDrop ? { name: 'AirDrop', Icon: AirDropIcon } : null,
    survey ? { name: 'Survey', Icon: SurveyIcon } : null,
    qr ? { name: 'QR Code', Icon: QRIcon } : null,
    print ? { name: 'Print', Icon: PrintIcon } : null,
  ];

  return (
    <ul className="share-types">
      {groups
        .filter((g) => g)
        .map(({ name, Icon }) => (
          <li className="share-types__type" key={name}>
            <Icon />
            <span className="share-types__name">{name}</span>
          </li>
        ))}
    </ul>
  );
};

export default ShareDemo;
